import { render, staticRenderFns } from "./MDaccount.vue?vue&type=template&id=4aac7e4b"
import script from "./MDaccount.vue?vue&type=script&lang=js"
export * from "./MDaccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports